var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":_vm.fill,"viewBox":"0 0 1280 121.69"}},[_c('path',{attrs:{"d":"m1280,121.69H0l53.33-31.9C106.67,57.88,213.33-5.93,320,.45s213.33,82.95,320,82.95S853.33,6.83,960,.45c106.67-6.38,213.33,57.43,266.67,89.34l53.33,31.9Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }